module.exports = __webpack_public_path__ + "img/worksbot_img19112539.d60c1158.jpg";